import Vue from 'vue'
import axios from 'axios';


Vue.prototype.$manifestarAnonimo = async (manifesto) =>{
  try { 
    let res = await axios.post('/manifestacaos',{
        anonimo: 1,
        id_usuario: 0,
        tipo_usuario: 'cidadao',
        tipo_assunto: manifesto['tipo'],
        secretaria: manifesto['secretaria'],
        assunto: manifesto['assunto'],
        conteudo: manifesto['descricao'],
        rua: manifesto['rua'],
        numero: manifesto['numero'],
        bairro: manifesto['bairro'],
        complemento: manifesto['complemento']
    });
    return res.data;
  } catch (e) {
    throw e;
  }  
}


